var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "el_module",
      staticClass: "module",
      class: [
        _vm.type === "edit" ? "center_module_edit" : "left_module_view",
        _vm.is_select ? "now_module_select" : "",
        _vm.module_selectable,
        _vm.module.lock ? "module_locking" : "",
        _vm.module.var ? "variable_module" : "",
      ],
      style: {
        width: _vm.module.style.width + "px",
        height: _vm.module.style.height + "px",
        top: _vm.module.style.top + "px",
        left: _vm.module.style.left + "px",
        opacity: _vm.module.style.opacity,
      },
      attrs: {
        id: _vm.type === "edit" ? "u" + _vm.module.tid : "v" + _vm.module.tid,
        name: _vm.module.name,
        cmptype: _vm.module.cmpType,
      },
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
          return _vm.module_mousedown.apply(null, arguments)
        },
        mouseup: _vm.module_mouseup,
        click: function ($event) {
          $event.stopPropagation()
          return _vm.select_module.apply(null, arguments)
        },
        dblclick: _vm.on_dblclick_module,
        contextmenu: function ($event) {
          $event.stopPropagation()
          return _vm.module_contextmenu.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "relativeFrame",
          style: {
            transform: `rotate(${_vm.module.style.rotate}deg)`,
          },
        },
        [
          _c(_vm.module.cmpType + "_index", {
            ref: "widget",
            tag: "component",
            attrs: { module: _vm.module, index: _vm.index, type: _vm.type },
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.m_ctrl_visible,
                  expression: "m_ctrl_visible",
                },
              ],
              staticClass: "m_ctrl",
              on: { dblclick: _vm.ondblclick },
            },
            [
              _vm.module.var
                ? _c("div", { staticClass: "flag" }, [_vm._v("变量")])
                : _vm._e(),
            ]
          ),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.module.lock,
                expression: "module.lock",
              },
            ],
            staticClass: "module_locking_mantle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
              mouseup: function ($event) {
                $event.stopPropagation()
              },
            },
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type === "edit" && !_vm.module.lock,
                  expression: "type === 'edit' && !module.lock",
                },
              ],
              staticClass: "rotate_icon",
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_c("i", { staticClass: "el-icon-reset rotate_icon_btn" })]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type === "edit" && !_vm.module.lock,
                  expression: "type === 'edit' && !module.lock ",
                },
              ],
              staticClass: "operate_button",
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "delete button mr-16",
                  on: { click: _vm.delect },
                },
                [
                  _c(
                    "svg",
                    { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                    [_c("use", { attrs: { "xlink:href": "#icon-shanshu14" } })]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "copy button", on: { click: _vm.copy } },
                [_vm._v("+1")]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }